export default __webpack_public_path__ + "static/media/award2.80822405.svg";